import React from "react";
import { useParams } from "react-router";

const NotFound = () => {
  let { id } = useParams();
  return <div>404 not found</div>;
};

export default NotFound;
